import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Music } from './pages/Music';
import { Guestbook } from './pages/Guestbook';
import { Tour } from './pages/Tour';
import { Shop } from './pages/Shop';
import { Subscribers } from './pages/Subscribers';
function AppShell() {
  return <div className="min-h-screen bg-[#f5f5f5] text-black flex flex-col" data-id="element-0" data-mp="3fb19tsiiipgn">
      <div className="flex-1" data-id="element-1" data-mp="2rlypue0eokiz">
        <Routes data-id="element-2" data-mp="2rl6u936t6msp">
          <Route path="/" element={<Home data-id="element-4" data-mp="2mmceka451ect" />} data-id="element-3" data-mp="2riklj086m18w" />
          <Route path="/music" element={<Music data-id="element-6" data-mp="2mnng03a42a0r" />} data-id="element-5" data-mp="2mmvj8p4s268w" />
          <Route path="/tour" element={<Tour data-id="element-8" data-mp="31b8lg3ugklbu" />} data-id="element-7" data-mp="2mjzplczyq3q9" />
          <Route path="/shop" element={<Shop data-id="element-10" data-mp="31c1l6kv02akh" />} data-id="element-9" data-mp="31bib1qblcqh0" />
          <Route path="/guestbook" element={<Guestbook data-id="element-12" data-mp="2wjqft2hhpwkj" />} data-id="element-11" data-mp="2wk08wyxu0jug" />
          <Route path="/subscribers" element={<Subscribers data-id="element-14" data-mp="28ufpkexrnkkn" />} data-id="element-13" data-mp="2wifgbev2vaz8" />
        </Routes>
      </div>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-15" data-mp="23vcikoy874a1">
      <AppShell data-id="element-16" data-mp="23vulg4fe8gqx" />
    </BrowserRouter>;
}